import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUtilDomModule } from '@mode/shared/util-js';
import { StoreModule } from '@ngrx/store';
import * as fromUser from './user/user.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UserEffects } from './user/user.effects';
import * as fromOrg from './org/org.reducer';
import { OrgEffects } from './org/org.effects';
import * as fromPreference from './preference/preference.reducer';
import { PreferenceEffects } from './preference/preference.effects';
import * as fromColorPalette from './color-palette/color-palette.reducer';
import { ColorPaletteEffects } from './color-palette/color-palette.effects';
import { SharedDataAccessWebappModule } from '@mode/shared/data-access-webapp';
import * as fromDatasource from './datasource/datasource.reducer';
import { DatasourceEffects } from './datasource/datasource.effects';
import * as fromAdmin from './admin/admin.reducer';
import { AdminEffects } from './admin/admin.effects';
import * as fromEmailAdmin from './email-admin/email-admin.reducer';
import { EmailAdminEffects } from './email-admin/email-admin.effects';
import * as fromCollection from './collection/collection.reducer';
import { CollectionEffects } from './collection/collection.effects';
import * as fromViewedReportIds from './viewed-report-ids/viewed-report-ids.reducer';
import { ViewedReportIdsEffects } from './viewed-report-ids/viewed-report-ids.effects';
import { AccountFacade } from '@mode/accounts/contract';
import { AccountFacadeService } from './account-facade.service';

@NgModule({
  imports: [
    CommonModule,
    SharedDataAccessWebappModule,
    SharedUtilDomModule,
    StoreModule.forFeature(fromUser.userFeatureKey, fromUser.reducer),
    StoreModule.forFeature(fromOrg.orgFeatureKey, fromOrg.reducer),
    StoreModule.forFeature(fromPreference.preferenceFeatureKey, fromPreference.reducer),
    StoreModule.forFeature(fromColorPalette.colorPaletteFeatureKey, fromColorPalette.reducer),
    StoreModule.forFeature(fromDatasource.datasourceFeatureKey, fromDatasource.reducer),
    StoreModule.forFeature(fromViewedReportIds.viewedReportIdsFeatureKey, fromViewedReportIds.reducer),
    EffectsModule.forFeature([
      UserEffects,
      OrgEffects,
      PreferenceEffects,
      ColorPaletteEffects,
      DatasourceEffects,
      AdminEffects,
      EmailAdminEffects,
      CollectionEffects,
      ViewedReportIdsEffects,
    ]),
    StoreModule.forFeature(fromAdmin.adminFeatureKey, fromAdmin.reducer),
    StoreModule.forFeature(fromEmailAdmin.emailAdminFeatureKey, fromEmailAdmin.reducer),
    StoreModule.forFeature(fromCollection.collectionFeatureKey, fromCollection.reducer),
  ],
  providers: [{ provide: AccountFacade, useClass: AccountFacadeService }],
})
export class AccountsDomainModule {}
